import styled from 'styled-components';
import { StyledCard } from '../../../components/Card.component';

export const StyledInternshipRecordsHeaderActions = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;
export const StyledInternshipRecordsHeaderTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
`;
export const StyledInternshipRecordsHeader = styled(StyledCard)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 10px 20px;
`;

export const StyledInternshipInfoTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
`;
export const StyledInternshipRecords = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: auto;
  max-height: calc(100vh - 104px);
  margin: -20px -15px -42px;
  padding: 20px 9px 42px 15px;
  transition: all 0.3s;
`;

export const StyledInternshipInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 0.5rem;
`;

export const StyledInternshipInfoBlocks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledInternshipPage = styled.div`
  padding: 22px;
  display: grid;
  grid-template-columns: 350px auto;
  gap: 22px;
  overflow: auto;
  height: calc(100vh - 105px);
`;

export const StyledStatusGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledFilterWrapper = styled.div`
  display: grid;
  gap: 5px;
  grid-template-columns: 300px 250px;

  & > div {
    align-self: center;
  }
`;
